import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import practiceReducer from './slices/practice';
import singlePracticeReducer from './slices/singlePractice';
import practiceTreatmentReducer from './slices/practiceTreatment';
import practiceMessageReducer from './slices/practiceMessage';
import practiceTreatmentListReducer from './slices/practiceTreatmentList';
import practiceUserReducer from './slices/practiceUser';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import userReducer from './slices/user';
import leadReducer from './slices/lead';
import forgotpasswordReducer from './slices/forgotpass';
import tagsCreateReducer from './slices/tagsCreate';
import practiceIntegrationReducer from './slices/practiceIntegration';
import activityReducer from './slices/activity';
import analyticsReducer from './slices/analytics';
import afterLoginReducer from './slices/afterLogin';
import autoReminderReducer from './slices/autoReminder';
import superAdminReducer from './slices/superAdmin';
import callScriptReducer from './slices/callScript';
import chatReducer from './slices/chat';
import loanReducer from './slices/loan';
import financialReducer from './slices/financialTracker';
import campaignReducer from './slices/campaign';
import duplicateReducer from './slices/duplicateLeads';
import clinCheckReducer from './slices/clincheck';
import audienceManagerReducer from './slices/audienceManager';
import archiveReducer from './slices/archive';
import tablePreferencesReducer from './slices/tablePreferences';
import customTableTabsReducer from './slices/customTableTabs';
import builtInTabOverridesReducer from './slices/builtInTabOverrides';
import multiTreatmentReducer from './slices/multiTreatment';
import widgetCounterReducer from './slices/widgetCounter';
import toDoNotificationsReducer from './slices/toDoNotifications';
import schemaReducer from './slices/schema';
import emailCounterReducer from './slices/emailCounter';
import feedbackReviewReducer from './slices/feedbackReview';
import practiceChatbotReducer from './slices/practiceChatbot';
import postsReducer from './slices/postSlice';
import whatsappAccountReducer from './slices/whatsappAccount';
import whatsAppReducer from './slices/whatsapp';
import liveNotificationsReducer from './slices/liveNotificationSlice';
import whatsappMessagesReducer from './slices/whatsAppMessages';
import depositReducer from './slices/deposit';
import settingsTemplateReducer from './slices/settingsTemplate';
import loaderReducer from './slices/loader';
import callScriptV2Reducer from './slices/callScriptV2';
import mergeTagReducer from "./slices/mergeTags";
import allPracticeReports from "./slices/allPracticeReports";
import whatsappV2 from "./slices/whatsappV2";
import analyticsReports from "./slices/analyticsReports";
import patientsReducer from './slices/patients';
import reviewStatsCacheReducer from './slices/reviewStatsCache';
import practiceCallLogsReducer from './slices/practiceCallLogs';
import googleAdsReducer from './slices/googleAds';
import googleAnalyticsReducer from './slices/googleAnalytics';
import metaAdsReducer from './slices/metaAds';
import dentallyPractitionersReducer from './slices/dentallyPractitioners';
import instagramReducer from './slices/instagram';
import userPerformanceReducer from './slices/userPerformance';
import superAdminUsersReducer from './slices/superAdminUsers';
import superAdminDomainsReducer from './slices/superAdminDomains';
import campaignBuilderReducer from './slices/campaignBuilder';
import spamLeadsReducer from './slices/spamLeads';
import createLeadDialogReducer from './slices/createLeadDialog';
import tiktokIntegrationReducer from './slices/tiktokIntegration';
import consentFormReducer from './slices/consentForm';
import bookingIntegrationReducer from './slices/bookingIntegration';
import dentallyReportingReducer from './slices/dentallyReporting';
import superAdminPracticesReducer from './slices/superAdminPractices';
import consentV2Reducer from './slices/consentV2';
import formDeliveriesReducer from './slices/formDeliveries';
import permissionsReducer from './slices/permissions';
import pmsScheduleReducer from './slices/pmsSchedule';
import groupDashboardReducer from './slices/groupDashboard';
import contactRoundReducer from './slices/contactRound';
import surveyFormReducer from './slices/surveyForm';
import taskReducer from './slices/taskSlice';
import taskNotificationReducer from './slices/taskNotificationSlice';
import taskTemplateReducer from './slices/taskTemplateSlice';
import storageReducer from './slices/storage';
import formReportsReducer from './slices/formReports';
import tasksV2MigrationReducer from './slices/tasksV2Migration';
import tasksV2DryRunPreviewReducer from './slices/tasksV2DryRunPreview';
import tasksV2ExecuteResultsReducer from './slices/tasksV2ExecuteResults';
// Cockpit-coverage trio (Solutions A / B / C — see PLAN.md at
// /Freelance Projects/tasks-v2-migration-cockpit-coverage/PLAN.md).
// Each is a standalone slice intentionally separate from
// tasksV2Migration to keep the cockpit-master slice from growing
// unbounded.
import tasksV2DefaultTemplatesReducer from './slices/tasksV2DefaultTemplates';
import tasksV2ChecklistConfigReducer from './slices/tasksV2ChecklistConfig';
import tasksV2CoverageMatrixReducer from './slices/tasksV2CoverageMatrix';
// Mirror Activity Feed (Slice 1) + lineage drawer (Slice 2). Same
// "isolated slice per panel" rationale as the cockpit-coverage trio
// above — keeps the omnibus tasksV2Migration slice from churning every
// time the activity feed paginates or the drawer opens.
import tasksV2MirrorActivityReducer from './slices/tasksV2MirrorActivity';
import systemTemplatesReducer from './slices/systemTemplates';
// PR-9 — per-practice patient acknowledgement toggles surfaced in the
// super-admin Notification Management screen alongside (not replacing)
// the existing staff-side notification config tabs.
import patientNotificationPreferencesReducer from './slices/patientNotificationPreferences';

const rootPersistConfig = {
    key: 'root',
    storage,
    keyPrefix: 'redux-',
    whitelist: ['whatsApp', 'mergeTags', 'reviewStatsCache', 'permissions'],
};

const rootReducer = combineReducers({
    whatsappV2,
    allPracticeReports,
    analyticsReports,
    mail: mailReducer,
    calendar: calendarReducer,
    kanban: kanbanReducer,
    user: userReducer,
    lead: leadReducer,
    forgotpassword: forgotpasswordReducer,
    practice: practiceReducer,
    singlePractice: singlePracticeReducer,
    practiceTreatment: practiceTreatmentReducer,
    practiceMessage: practiceMessageReducer,
    practiceTreatmentList: practiceTreatmentListReducer,
    practiceUser: practiceUserReducer,
    tagsCreate: tagsCreateReducer,
    practiceIntegration: practiceIntegrationReducer,
    activity: activityReducer,
    analytics: analyticsReducer,
    afterLogin: afterLoginReducer,
    autoReminder: autoReminderReducer,
    superAdmin: superAdminReducer,
    callScript: callScriptReducer,
    chat: chatReducer,
    loan: loanReducer,
    financialTracker: financialReducer,
    campaign: campaignReducer,
    duplicate: duplicateReducer,
    clinCheck: clinCheckReducer,
    audienceManager: audienceManagerReducer,
    archive: archiveReducer,
    tablePreferences: tablePreferencesReducer,
    customTableTabs: customTableTabsReducer,
    builtInTabOverrides: builtInTabOverridesReducer,
    multiTreatment: multiTreatmentReducer,
    widgetCounter: widgetCounterReducer,
    toDoNotifications: toDoNotificationsReducer,
    schema: schemaReducer,
    emailCounter: emailCounterReducer,
    feedbackReview: feedbackReviewReducer,
    practiceChatbot: practiceChatbotReducer,
    posts: postsReducer,
    whatsappAccount: whatsappAccountReducer,
    whatsApp: whatsAppReducer,
    liveNotifications: liveNotificationsReducer,
    whatsappMessages: whatsappMessagesReducer,
    deposit: depositReducer,
    settingsTemplate: settingsTemplateReducer,
    loaderReducer,
    callScriptV2: callScriptV2Reducer,
    mergeTags: mergeTagReducer,
    patients: patientsReducer,
    reviewStatsCache: reviewStatsCacheReducer,
    practiceCallLogs: practiceCallLogsReducer,
    googleAds: googleAdsReducer,
    googleAnalytics: googleAnalyticsReducer,
    metaAds: metaAdsReducer,
    dentallyPractitioners: dentallyPractitionersReducer,
    instagram: instagramReducer,
    userPerformance: userPerformanceReducer,
    superAdminUsers: superAdminUsersReducer,
    superAdminDomains: superAdminDomainsReducer,
    campaignBuilder: campaignBuilderReducer,
    spamLeads: spamLeadsReducer,
    createLeadDialog: createLeadDialogReducer,
    tiktokIntegration: tiktokIntegrationReducer,
    consentForm: consentFormReducer,
    bookingIntegration: bookingIntegrationReducer,
    dentallyReporting: dentallyReportingReducer,
    superAdminPractices: superAdminPracticesReducer,
    consentV2: consentV2Reducer,
    formDeliveries: formDeliveriesReducer,
    permissions: permissionsReducer,
    pmsSchedule: pmsScheduleReducer,
    groupDashboard: groupDashboardReducer,
    contactRound: contactRoundReducer,
    surveyForm: surveyFormReducer,
    task: taskReducer,
    taskNotification: taskNotificationReducer,
    taskTemplate: taskTemplateReducer,
    storage: storageReducer,
    formReports: formReportsReducer,
    tasksV2Migration: tasksV2MigrationReducer,
    tasksV2DryRunPreview: tasksV2DryRunPreviewReducer,
    tasksV2ExecuteResults: tasksV2ExecuteResultsReducer,
    tasksV2DefaultTemplates: tasksV2DefaultTemplatesReducer,
    tasksV2ChecklistConfig: tasksV2ChecklistConfigReducer,
    tasksV2CoverageMatrix: tasksV2CoverageMatrixReducer,
    tasksV2MirrorActivity: tasksV2MirrorActivityReducer,
    systemTemplates: systemTemplatesReducer,
    patientNotificationPreferences: patientNotificationPreferencesReducer,
});

export { rootPersistConfig, rootReducer };
